var React = require("react");

var ApplicationContext = require("../../config/ApplicationContext.js");
var Utility =            require("../../util/Utilities.js");

var Iframe =             require("./Iframe.jsx")
var ContainsOrUsed =     require("./ContainsOrUsed.jsx")

class DetailsElementPreview extends React.Component {

    constructor(){
        super();
    }

    render() {
        let {id, name, user_name, summary, type, version, updated_at, useIn, contains} = this.props;
        let base = type === "component" ? ApplicationContext.getComponentEditor():
                    type === "package" ? ApplicationContext.getPackageEditor():
                    type === "symbol" ? ApplicationContext.getSymbolEditor():
                                        ApplicationContext.getFootprintEditor();
        
        summary = Utility.formatDescription(summary) || "No summary";
        updated_at = Utility.formatDateMonthString(updated_at);
        
        return  <React.Fragment>
                    <Iframe base={base} id={id} version={version}/>
                    <div className="detailsElementPreview">
                        <h3 className="detailsElementPreview__name">{name}</h3>
                        <div className="detailsElementPreview__details">
                            <p className="property">Type</p><p className="num">{type}</p>
                            <p className="property">User</p><p className="num">{user_name}</p>
                            <p className="property">Summary</p><p className="num">{summary}</p>
                            <p className="property">Version</p><p className="num">{version}</p>
                            <p className="property">Date Created</p><p className="num">{updated_at}</p>
                        </div>
                        <div className="detailsElementPreview__contains">
                            {contains && contains.length > 0 &&
                                <React.Fragment>
                                <h3 className="property">Contains</h3>
                                {contains.map((info, index) => <ContainsOrUsed key={info.id || index} {...info} showItem={this.props.showItem}/>)}
                                </React.Fragment>
                            }
                            {useIn && useIn.length > 0 &&
                                <React.Fragment>
                                <h3 className="property usedIn">Used In</h3>
                                {useIn.map((info, index) => <ContainsOrUsed key={info.id || index} {...info} showItem={this.props.showItem}/>)}
                                </React.Fragment>
                            }
                            
                        </div>

                    </div>
                </React.Fragment>
    }
};

module.exports = DetailsElementPreview;
